  document.addEventListener("DOMContentLoaded", function() {
      const titleElement = document.querySelector("title");
      const titleText = titleElement.textContent.trim().replace(/\s+/g, ' '); // Replace consecutive whitespace characters with a single space

      if (titleText === "Chapter 3 – She-Wolf") {
        console.log(titleText);
          // Find the div with class "section-template--22592413663548__product-grid-padding"
          const targetDiv = document.querySelector(".section-template--23973547049281__product-grid-padding");
          console.log(targetDiv);
        // const targetDiv = document.querySelector(".section-template--22704071311676__product-grid-padding");

          if (targetDiv) {
              // Create an image element
              const image = document.createElement("img");

              // Set the image source
              image.src = "https://cdn.shopify.com/s/files/1/0916/0143/6993/files/Kalyugam_Banners_8.png?v=1738847781";

              // Add a class to the image
              image.classList.add("images-banner-custom");

              // Make the image the first child of the target div
              targetDiv.insertBefore(image, targetDiv.firstChild);
          }
        const facetsVerticalElements1 = document.querySelectorAll(".title--primary");
        facetsVerticalElements1.forEach(element => {
            element.style.display = "none";
        });

        const facetsVerticalElements2 = document.querySelectorAll(".facets-container");
        facetsVerticalElements2.forEach(element => {
            element.style.display = "none";
        });
        
      }
  });